export const audiences = {
  ARCHIVIST: {
    id: '0000019e-3c10-d4a5-a19e-febd2a290000',
  },
  FAMILY: {
    id: '0000019e-3c15-d1bb-a3bf-fd5711210000',
  },
  LATTER_DAY_SAINT: {
    id: '0000019e-3c13-d4a5-a19e-febfe6490000',
  },
}
